export default [
    {
        path: '/airline/target',
        props: true,
        component: () => import('@/views/Airline/Target'),
    },
];